// Place-Prefecture-Country Dropdown menu for models

// console.log('dropdown JS file is going to be read.');

import {dropdownCountry2Place} from './dropdown_country2place.js';

const models = ["artist", "event_group", "event", "event_item", "harami_vid", "music", "place"];

models.forEach(dropdownCountry2Place);

